import {
  Button,
  Dropdown,
  Flex,
  Input,
  message,
  Modal,
  Space,
  Table,
} from "antd";
import { useRef, useState } from "react";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { ExclamationCircleFilled } from "@ant-design/icons";

import {
  useAdminGetAllUserQuery,
  useDeleteUserMutation,
} from "../../redux/Service/api";
import AddAdmin from "./AddAdmin";
// import Loading from "../../components/utils/Loading";

const { confirm } = Modal;

const UsersControl = () => {
  const [searchText, setSearchText] = useState("");
  const [openAddModal, setOpenAddModal] = useState(false);

  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const [
    deleteUser,
    { isLoading: delIsLoading, isError: delIsError, error: delError },
  ] = useDeleteUserMutation();

  const {
    data: allUsersData,
    isError: isUsersDataError,
    isLoading: isUsersDataLoading,
    error: usersDatacatError,
  } = useAdminGetAllUserQuery();
  const allUsers = allUsersData?.data ?? null;

  const data = allUsers?.map((user) => {
    return {
      key: user.id,
      name: user.name,
      email: user.email,
      status: user.role,
      created_at: user.created_at,
    };
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "name",
      dataIndex: "name",
      key: "name",
      ...getColumnSearchProps("name"),
      width: 150,
    },
    {
      title: "email",
      dataIndex: "email",
      key: "email",
      ...getColumnSearchProps("email"),
      width: 130,
    },
    {
      title: "role",
      dataIndex: "status",
      key: "status",
      ...getColumnSearchProps("status"),
      width: 100,
    },
    {
      title: "created at",
      dataIndex: "created_at",
      key: "created_at",
      ...getColumnSearchProps("created_at"),
      width: 100,
    },
    {
      title: "actions",
      key: "actions",
      render: (userDataMapper) => {
        return (
          <div className="d-flex gap-2">
            <Button
              type="primary"
              danger
              ghost
              onClick={() => handleDeleteUserClick(userDataMapper.key)}
            >
              Delete
            </Button>
          </div>
        );
      },
      width: 100,
    },
  ];

  const handleDeleteUserClick = async (id) => {
    confirm({
      title: "Do you want to delete this user?",
      icon: <ExclamationCircleFilled />,
      content: "When clicked the OK button, this user will be removed",
      async onOk() {
        try {
          const res = await deleteUser(id);
          res.data.message
            ? message.info(res.data.message)
            : message.success("User is deleted successfully");
        } catch (error) {
          console.log(error);
        }
      },
      onCancel() {},
    });
  };
  return (
    <>
      <article className="users position-relative" style={{ direction: "ltr" }}>
        {isUsersDataError && (
          <p className="text-danger">Something went error</p>
        )}
        <article className="container users_container">
          <h2 className="main_heading">Users</h2>
          <Flex
            gap="small"
            wrap="nowrap"
            className="justify-content-center mb-5"
          >
            <Button type="primary" onClick={() => setOpenAddModal(true)}>
              <FontAwesomeIcon icon={faPlus} /> Add Admin{" "}
            </Button>
          </Flex>
          <Table
            columns={columns}
            dataSource={data}
            loading={isUsersDataLoading}
            bordered
            rowClassName={"rowName"}
            pagination={{
              showSizeChanger: true,
              pageSizeOptions: [9, 10, 20, 30, 50],
              showTotal: (total) => `العدد الكلي: ${total}`,
            }}
            scroll={{ y: 400, x: 500 }}
          />
        </article>
      </article>
      <AddAdmin setOpenAddModal={setOpenAddModal} openAddModal={openAddModal} />
    </>
  );
};
export default UsersControl;
